import { useMemo } from "react";

import { colorsPalettes } from "@similarweb/styles";

import { trafficSourcesForSegments } from "app/Shared/utils";
import { useTranslation } from "pro-features/components/WithTranslation";

import { trafficSources } from "../../constants";
import { useChannelsOverviewData } from "../useChannelsOverviewData";

const colorSet = [
    colorsPalettes.midnight[500],
    colorsPalettes.blue[600],
    colorsPalettes.blue[500],
    colorsPalettes.blue[400],
    colorsPalettes.blue[350],
    colorsPalettes.blue[300],
    colorsPalettes.sky[200],
    colorsPalettes.blue[100],
    colorsPalettes.midnight[50],
    colorsPalettes.sky[300],
    colorsPalettes.blue[200],
];

export interface IChartData {
    color: string;
    name: string;
    id: string;
    key: string;
    visible: boolean;
    y?: number;
}

export const useChartData = () => {
    const translate = useTranslation();
    const { data: channelsData, isLoading, isError } = useChannelsOverviewData();

    const data = useMemo<{ data: IChartData[] }[] | null>(() => {
        if (!channelsData?.primaryData) {
            return null;
        }

        return [
            {
                data: [...trafficSources]
                    .sort((a, b) => {
                        if (channelsData.primaryData[a] == null) {
                            return 1;
                        }

                        if (channelsData.primaryData[b] == null) {
                            return -1;
                        }

                        return channelsData.primaryData[b] - channelsData.primaryData[a];
                    })
                    .map(
                        (key, index) =>
                            ({
                                color: colorSet[index],
                                name: translate(trafficSourcesForSegments[key].title),
                                id: key,
                                key: key,
                                visible: true,
                                y: channelsData.primaryData[key],
                            }) satisfies IChartData,
                    ),
            },
        ];
    }, [channelsData, translate]);

    return {
        data,
        isLoading,
        isError,
    };
};
